import React, { FC, useEffect, useState } from 'react';
import { TCourier } from '../../services/api';
import { EBottomSheetAction, TBottomSheetAction } from '../CourierBottomSheet';
import { CourierDetailView } from '../CourierDetailView';
import { CourierData } from '../CourierData';
import CourierDetailActionsAdd from '../CourierDetailActionsAdd';
import { CourierDetailActionsDelete } from '../CourierDetailActionsDelete';
import { CourierDetailActionsResend } from '../CourierDetailActionsResend';
import CourierSettingsTips, { TRestuarantSettings } from '../CourierSettingsTips';
import CourierDetailActionsConfirm from '../CourierDetailActionsConfirm';
import styles from './CourierDialogPopup.module.scss';
import PIEModal from '@src/shared/components/PIEModal';

interface ICourierDialogPopupProps {
  dataObject: TCourier;
  selectedCourier?: string;
  actionType?: TBottomSheetAction;
  disableBackdropClick?: boolean;
  onDialogClose: () => void;
  resturantSettings: TRestuarantSettings;
}

export const CourierDialogPopup: FC<ICourierDialogPopupProps> = ({
  dataObject,
  actionType,
  disableBackdropClick = false,
  onDialogClose,
  resturantSettings,
}) => {
  /* Component State */
  const [bottomSheetAction, setBottomSheetAction] = useState<TBottomSheetAction>();
  const [openDialog, setOpenDialog] = useState(false);

  /* Event Actions */
  const handleOnAction = (action: TBottomSheetAction) => {
    setOpenDialog(false);
    if (
      action.type === EBottomSheetAction.Delete ||
      action.type === EBottomSheetAction.Disconnect ||
      action.type === EBottomSheetAction.ConfirmationPending
    ) {
      setTimeout(() => {
        setBottomSheetAction(action);
        setOpenDialog(true);
      }, 200);
    }
  };

  const handleOnDismiss = () => {
    setOpenDialog(false);
    onDialogClose();
  };

  const handleOnCloseClick = () => {
    setOpenDialog(false);
    onDialogClose();
  };

  const handleOnDelete = () => {
    //console.log('OnDelete');
  };

  /* SideEffects */
  useEffect(() => {
    if (actionType !== undefined) {
      setBottomSheetAction(actionType);
      setOpenDialog(true);
    }
    return () => {
      setOpenDialog(false), setBottomSheetAction(undefined);
    };
  }, [actionType]);

  return (
    (openDialog && (
      <PIEModal
        className={styles.courierDialogPopup}
        modPositionCenter={true}
        isOpen={openDialog}
        onClose={() => {
          handleOnDismiss();
        }}
        size="small"
        modCloseOnOverlayClick={!disableBackdropClick}
      >
        {bottomSheetAction?.type === EBottomSheetAction.View ? (
          <PIEModal.Content modNoPadding>
            <CourierDetailView onDismiss={handleOnCloseClick}>
              <CourierData onAction={handleOnAction} {...dataObject} />
            </CourierDetailView>
          </PIEModal.Content>
        ) : null}

        {bottomSheetAction?.type === EBottomSheetAction.ReSend ? (
          <PIEModal.Content modNoPadding>
            <CourierDetailView onDismiss={handleOnCloseClick}>
              <CourierDetailActionsResend
                onAction={handleOnAction}
                onDismiss={handleOnDismiss}
                {...dataObject}
              />
            </CourierDetailView>
          </PIEModal.Content>
        ) : null}

        {bottomSheetAction?.type === EBottomSheetAction.Delete ||
        bottomSheetAction?.type === EBottomSheetAction.Disconnect ? (
          <PIEModal.Footer>
            <CourierDetailActionsDelete
              onDismiss={handleOnDismiss}
              onAction={handleOnDelete}
              action={bottomSheetAction}
            ></CourierDetailActionsDelete>
          </PIEModal.Footer>
        ) : null}

        {bottomSheetAction?.type === EBottomSheetAction.ConfirmationPending ? (
          <PIEModal.Footer>
            <CourierDetailActionsConfirm
              onDismiss={handleOnDismiss}
              onAction={handleOnAction}
              bottomSheetAction={bottomSheetAction}
            ></CourierDetailActionsConfirm>
          </PIEModal.Footer>
        ) : null}

        {bottomSheetAction?.type === EBottomSheetAction.Add ? (
          <CourierDetailView onDismiss={handleOnCloseClick}>
            {<CourierDetailActionsAdd onActionSuccess={handleOnDismiss} />}
          </CourierDetailView>
        ) : null}

        {bottomSheetAction?.type === EBottomSheetAction.Tips ? (
          <PIEModal.Content modNoPadding>
            <CourierDetailView onDismiss={handleOnCloseClick} viewType="tips">
              <CourierSettingsTips
                modeConfirmPending={false}
                onAction={handleOnAction}
                onDismiss={handleOnDismiss}
                restaurantSettings={{ showTips: resturantSettings.showTips }}
              ></CourierSettingsTips>
            </CourierDetailView>
          </PIEModal.Content>
        ) : null}
      </PIEModal>
    )) ||
    null
  );
};
